// Filter configurations for different modules
export const FILTER_CONFIGS = {
    expenses: {
        showDateRange: true,
        showProject: true,
        showVendor: true,
        showCreatedBy: true,
        showWorker: true
    },
    projects: {
        showDateRange: false,
        showProject: true,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false
    },
    workers: {
        showDateRange: false,
        showProject: true,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false
    },
    vendors: {
        showDateRange: true,
        showProject: false,
        showVendor: false,
        showCreatedBy: true,
        showWorker: false
    },
    tasks: {
        showDateRange: false,
        showProject: true,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false
    },
    'dashboard-workers': {
        showDateRange: false,
        showProject: true,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false,
        showDirectWorker: false
    },
    'super-admin-projects': {
        showDateRange: false,
        showProject: false,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false,
        showStatus: true
    },
    'super-admin-organizations': {
        showDateRange: false,
        showProject: false,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false,
        showStatus: true,
        showPlan: true
    },
    'super-admin-managers': {
        showDateRange: false,
        showProject: false,
        showVendor: false,
        showCreatedBy: false,
        showWorker: false,
        showStatus: true
    }
};

// Default filter configuration
export const DEFAULT_FILTER_CONFIG = {
    showDateRange: true,
    showProject: true,
    showVendor: true,
    showCreatedBy: true,
    showWorker: true
};

// Function to get filter configuration for a module
export const getFilterConfig = (moduleType, showProjectFilter = true) => {
    if (moduleType && FILTER_CONFIGS[moduleType]) {
        return FILTER_CONFIGS[moduleType];
    }

    // Return default config with showProjectFilter override
    return {
        ...DEFAULT_FILTER_CONFIG,
        showProject: showProjectFilter
    };
};
